<template>
	<v-expansion-panels focusable>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header>
				<v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-progress-download
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>PENDING </v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status pending on
						your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content>{{
							$t("label.email")
						}}</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.pending.enable_email"
								inset
								color="indigo"
								:label="
									item.pending.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.pending.enable_database"
								inset
								color="indigo"
								:label="
									item.pending.enable_database ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content>
							{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.pending.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.pending.enable_broadcast ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.pending.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.pending.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-cash-check
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>ACCEPTED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status accepted on
						your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.accepted.enable_email"
								inset
								color="indigo"
								:label="
									item.accepted.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.accepted.enable_database"
								inset
								color="indigo"
								:label="
									item.accepted.enable_database ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.accepted.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.accepted.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.accepted.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.accepted.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-credit-card-check-outline
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>PREPARING</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status preparing
						on your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.preparing.enable_email"
								inset
								color="indigo"
								:label="
									item.preparing.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.preparing.enable_database"
								inset
								color="indigo"
								:label="
									item.preparing.enable_database
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.preparing.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.preparing.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.preparing.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.preparing.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-book-check-outline
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>PREPARED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status prepared on
						your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content>{{
							$t("label.email")
						}}</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.prepared.enable_email"
								inset
								color="indigo"
								:label="
									item.prepared.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.prepared.enable_database"
								inset
								color="indigo"
								:label="
									item.prepared.enable_database ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.prepared.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.prepared.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.prepared.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.prepared.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-truck-check
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>DELIVERED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status delivered
						on your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.delivered.enable_email"
								inset
								color="indigo"
								:label="
									item.delivered.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.delivered.enable_database"
								inset
								color="indigo"
								:label="
									item.delivered.enable_database
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.delivered.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.delivered.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.delivered.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.delivered.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-shield-check
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>COMPLETED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status completed
						on your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.completed.enable_email"
								inset
								color="indigo"
								:label="
									item.completed.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.completed.enable_database"
								inset
								color="indigo"
								:label="
									item.completed.enable_database
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.completed.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.completed.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.completed.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.completed.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-basket-off-outline
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>DECLINED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status declined on
						your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.declined.enable_email"
								inset
								color="indigo"
								:label="
									item.declined.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.declined.enable_database"
								inset
								color="indigo"
								:label="
									item.declined.enable_database ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.declined.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.declined.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.declined.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.declined.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-divider></v-divider>
		<v-expansion-panel>
			<v-expansion-panel-header
				><v-list-item>
					<v-list-item-avatar>
						<v-icon
							class="grey"
							dark
							style="width: 25px; height: 25px"
						>
							mdi-cancel
						</v-icon>
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>CANCELED</v-list-item-title>

						<v-list-item-subtitle class="text-caption"
							>{{ $t("label.email") }},
							{{ $t("label.database") }},
							{{ $t("label.broadcast") }},
							{{ $t("label.fcmchannel") }}</v-list-item-subtitle
						>
					</v-list-item-content>
				</v-list-item></v-expansion-panel-header
			>
			<v-expansion-panel-content>
				<v-list>
					<v-list-item-subtitle class="text-caption pl-6"
						>These are notifications for comments status canceled on
						your orders and replies to your
						comments.</v-list-item-subtitle
					>
					<v-list-item-subtitle class="text-caption pl-7 pt-6"
						><strong
							>Where you receive these notifications</strong
						></v-list-item-subtitle
					>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-email-outline</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.email") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.canceled.enable_email"
								inset
								color="indigo"
								:label="
									item.canceled.enable_email ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-database</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.database") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.canceled.enable_database"
								inset
								color="indigo"
								:label="
									item.canceled.enable_database ? 'on' : 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-access-point-network</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.broadcast") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.canceled.enable_broadcast"
								inset
								color="indigo"
								:label="
									item.canceled.enable_broadcast
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-list>
					<v-list-item>
						<v-list-item-avatar>
							<v-icon>mdi-cellphone-nfc</v-icon>
						</v-list-item-avatar>

						<v-list-item-content
							>{{ $t("label.fcmchannel") }}
						</v-list-item-content>

						<v-list-item-action>
							<v-switch
								v-model="item.canceled.enable_fcmchannel"
								inset
								color="indigo"
								:label="
									item.canceled.enable_fcmchannel
										? 'on'
										: 'off'
								"
							></v-switch>
						</v-list-item-action>
					</v-list-item>
				</v-list>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>
<script>
export default {
	props: ["value"],
	data() {
		return {
			//
		};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>